/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Cannot_Unlink_Only_Sign_In_MethodInputs */

const en_mobile_cannot_unlink_only_sign_in_method = /** @type {(inputs: Mobile_Cannot_Unlink_Only_Sign_In_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot unlink your only sign-in method.`)
};

const es_mobile_cannot_unlink_only_sign_in_method = /** @type {(inputs: Mobile_Cannot_Unlink_Only_Sign_In_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No puedes desvincular tu único método de inicio de sesión.`)
};

/**
* | output |
* | --- |
* | "You cannot unlink your only sign-in method." |
*
* @param {Mobile_Cannot_Unlink_Only_Sign_In_MethodInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_cannot_unlink_only_sign_in_method = /** @type {((inputs?: Mobile_Cannot_Unlink_Only_Sign_In_MethodInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Cannot_Unlink_Only_Sign_In_MethodInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_cannot_unlink_only_sign_in_method(inputs)
	return en_mobile_cannot_unlink_only_sign_in_method(inputs)
});